import { Injectable } from '@angular/core';
import { CoreHttpClient } from '@core-modules/providers/core-http-client/core-http-client';
import { EnvironmentProvider } from '@core-modules/providers/environment-variables/environment';

import { Country } from '@core-modules/client-details/models/country';
import { MobileUserLocation } from './mobile-user-location';
/*
  Generated class for the ClientDetails provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ClientDetailsProvider
{

    //#region Constructor

    /**
     * Class constructor
     */
    constructor
        (
            private http: CoreHttpClient,
            private env: EnvironmentProvider
        )
    {

    }

    //#endregion


    //#region Methods

    /**
     * Get a list of countries
     */
    public async getCountries(): Promise<Country[]>
    {
        let url = `${this.env.apiEndpoint}/mobileapp/Geography/GetCountryList`;
        return (await this.http.get<Country[]>(url)).sort((a, b) => a.CountryName.localeCompare(b.CountryName));
    }

    //#endregion
}
